(() => {
  const initialize = () => {
    const params = new URLSearchParams(location.search);
    document.querySelectorAll('[data-bc-source]').forEach(input => { input.value = location.origin + location.pathname; });
    const campaign = ['utm_source', 'utm_medium', 'utm_campaign'].map(key => params.has(key) ? key + ': ' + params.get(key).slice(0,150) : '').filter(Boolean).join('; ');
    document.querySelectorAll('[data-bc-campaign]').forEach(input => { input.value = campaign; });
    const product = params.get('product');
    if (product) document.querySelectorAll('.bc-lead-form textarea').forEach(input => { if (!input.value) input.value = product.slice(0,500); });
    document.querySelectorAll('[data-bc-interest]').forEach(link => link.addEventListener('click', () => {
      document.querySelectorAll('[data-bc-interest-field]').forEach(select => { select.value = link.dataset.bcInterest; });
    }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
